import AdminProductForm from './AdminProductForm';

export default AdminProductForm;
